import { __rest } from "tslib";
import * as React from "react";
import { cn } from "../../lib/utils";
/**
 * @example
 *
 * ```jsx
 * import { LoadingSpinner } from "@skve/components"
 *
 * function Demo() {
 *   return <LoadingSpinner />
 * }
 * ```
 */
export const LoadingSpinner = (_a) => {
    var { size = 24, className } = _a, props = __rest(_a, ["size", "className"]);
    return (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size }, props, { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: cn("animate-spin", className) }),
        React.createElement("path", { d: "M21 12a9 9 0 1 1-6.219-8.56" })));
};
//# sourceMappingURL=loading-spinner.js.map